module.exports = __webpack_public_path__ + "img/gch1@2x.470a789d.png";